// src/components/UploadToFormReaderModal.jsx
import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import { FiUpload, FiX } from 'react-icons/fi';
import { toast } from 'react-toastify';

const API = `${process.env.REACT_APP_API_BASE_URL}/api`;
const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'multipart/form-data'
  }
});

export default function UploadToFormReaderModal({ formReaderId, close, refresh }) {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const onDrop = useCallback(accepted => {
    setFiles(prev => [...prev, ...accepted]);
  }, []);

  const removeFile = idx =>
    setFiles(prev => prev.filter((_, i) => i !== idx));

const handleUpload = async () => {
  if (!files.length) {
    toast.warn('Önce dosya seçin.');
    return;
  }

  setLoading(true); // yükleme başlıyor
  try {
    const formData = new FormData();
    files.forEach(f => formData.append('files[]', f, f.name));

    await axios.post(
      `${API}/form-reader/${formReaderId}/upload`,
      formData,
      authHeaders()
    );

    toast.success('Sayfalar eklendi.');
    refresh();
    close();

  } catch (err) {
    console.error(err);
    toast.error('Yükleme başarısız oldu.');
  } finally {
    setLoading(false); // her durumda butonu aç
  }
};

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png' : ['.png']
    }
  });

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show" />

      {/* Modal */}
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: 'block', zIndex: 1050 }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Sayfa Ekle</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={close}
              />
            </div>

            <div className="modal-body">
              {/* Dropzone bölümü */}
              <div
                {...getRootProps()}
                className={`border rounded p-4 text-center ${
                  isDragActive ? 'bg-light' : ''
                }`}
                style={{ cursor: 'pointer' }}
              >
                <input {...getInputProps()} />
                {files.length === 0 ? (
                  <p className="mb-0 text-muted">
                    Dosyaları sürükleyin veya tıklayın
                  </p>
                ) : (
                  <p className="mb-0 fw-semibold">
                    {files.length} sayfa seçildi
                  </p>
                )}
              </div>

              {/* Seçilen dosyaların listesi */}
              {files.length > 0 && (
                <ul
                  className="list-group list-group-flush mt-3"
                  style={{ maxHeight: 200, overflowY: 'auto' }}
                >
                  {files.map((f, i) => (
                    <li
                      key={i}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      {f.name}
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => removeFile(i)}
                      >
                        <FiX />
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={close}
              >
                İptal
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpload}
              >
                <FiUpload className="me-1" />
                Yükle &amp; Kapat
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
